import { Link } from "react-router-dom";
function ServiceNavigation({ prevLink, prevTitle, nextLink, nextTitle }) {
  return (
    <section
      style={{
        padding: "40px 5% 80px",
        background: "#fff",
      }}
    >
      <div
        style={{
          maxWidth: "1200px",
          margin: "0 auto",
          display: "flex",
          justifyContent: "space-between",
          gap: "20px",
          flexWrap: "wrap",
        }}
      >
        {prevLink ? (
          <Link
            to={prevLink}
            style={{
              textDecoration: "none",
              padding: "14px 30px",
              borderRadius: "50px",
              background: "#1a0a2e",
              color: "#fff",
              fontWeight: "600",
            }}
          >
            ← {prevTitle}
          </Link>
        ) : (
          <div />
        )}

        {nextLink ? (
          <Link
            to={nextLink}
            style={{
              textDecoration: "none",
              padding: "14px 30px",
              borderRadius: "50px",
              background: "#1a0a2e",
              color: "#fff",
              fontWeight: "600",
            }}
          >
            {nextTitle} →
          </Link>
        ) : (
          <div />
        )}
      </div>
    </section>
  );
}
export default ServiceNavigation;
